module.exports = __webpack_public_path__ + "img/settlement-pref.2e2aec6b.svg";